/*
 * Copyright (c) 2026. Citrix Systems, Inc. All Rights Reserved. Confidential & Proprietary
 */
import { AnalyticsEvent, Metadata, trackAnalyticsEvent } from 'analytics';
import { BrowserExtensionMessageType } from 'Environment/BrowserExtension/types';
import { clientType, getClientType } from 'Environment/getClientType';
import { BrowserExtensionEventType } from 'Workspace/TelemetryEvents/TelemetryEventTypes';
const code = 'WSUI_BROWSER_EXTENSION';

const preparePayload = (
	type: BrowserExtensionEventType,
	metadata?: Metadata
): AnalyticsEvent => ({
	type,
	code,
	...metadata,
});
const createBrowserExtensionAnalyticsReporter = () => {
	return {
		getBrowserExtensionAppLaunchEvent: () =>
			preparePayload(BrowserExtensionEventType.BrowserExtensionAppLaunch),
		getBrowserExtensionAppLaunchErrorEvent: (
			errorName: string,
			errorMessage: string,
			client: clientType
		): AnalyticsEvent =>
			preparePayload(BrowserExtensionEventType.BrowserExtensionAppLaunchError, {
				errorName,
				errorMessage,
				client,
			}),
		getIcaLaunchEvent: () =>
			preparePayload(BrowserExtensionEventType.BrowserExtensionIcaLaunch),
		getLeaseLaunchEvent: () =>
			preparePayload(BrowserExtensionEventType.BrowserExtensionLeaseLaunch),
		getLeaseLaunchEventWhenLeaseFallbackToIca: () =>
			preparePayload(
				BrowserExtensionEventType.BrowserExtensionLeaseLaunchLeaseFallbackToIca
			),
		getLeaseLaunchEventWhenIcaFallbackToLease: () =>
			preparePayload(
				BrowserExtensionEventType.BrowserExtensionLeaseLaunchIcaFallbackToLease
			),
		getLeaseLaunchEventWhenCloudOffline: () =>
			preparePayload(BrowserExtensionEventType.BrowserExtensionLeaseLaunchCloudOffline),
		getCloudOfflineEventWhenGetUserDetailsFailed: () =>
			preparePayload(
				BrowserExtensionEventType.BrowserExtensionCloudOfflineGetUserDetailsFailed
			),
		getCloudOfflineEventWhenUserTriggered: () =>
			preparePayload(BrowserExtensionEventType.BrowserExtensionCloudOfflineUserTriggered),
		// WSUI-12492: CAS event for a native-bridge response timeout (relocated from Sentry).
		getPostMessageErrorEvent: (metadata: {
			messageType: BrowserExtensionMessageType;
			correlationId?: string;
			errorMessage?: string;
		}): AnalyticsEvent =>
			preparePayload(
				BrowserExtensionEventType.BrowserExtensionPostMessageError,
				metadata
			),
	};
};

export function trackBrowserExtensionError(error: any) {
	trackAnalyticsEvent(
		browserExtensionAnalyticsReporter.getBrowserExtensionAppLaunchErrorEvent(
			error ? error.name : 'BE error',
			error ? error.message : 'Error occurred while launching app using BE',
			getClientType()
		)
	);
}

export const browserExtensionAnalyticsReporter =
	createBrowserExtensionAnalyticsReporter();
